import {Directive, Host, Input, OnDestroy, OnInit, SkipSelf} from '@angular/core';
import {ControlContainer} from '@angular/forms';
import {DatevMessageService} from '@datev/ngx-ui-components';

@Directive({
  selector: '[formControlName][utilsControlState]'
})
export class ControlStateDirective implements OnInit, OnDestroy {

  @Input()
  public formControlName: string;

  @Input()
  public datevMessagePath: string;

  constructor(private readonly datevMessageService: DatevMessageService,
              @Host() @SkipSelf() private readonly controlContainer: ControlContainer) {
  }

  public ngOnInit(): void {
    if (!this.controlContainer) {
      return;
    }

    const control = this.controlContainer.control.get(this.formControlName);
    if (control && control.disabled) {
      control.enable();
    }
  }

  public ngOnDestroy(): void {
    if (!this.controlContainer) {
      return;
    }

    const control = this.controlContainer.control.get(this.formControlName);

    this.datevMessageService.clearMessages(this.datevMessagePath);
    if (control) {
      // HACK: Um gelegentliche ExpressionChangedAfterItHasBeenCheckedError zu umgehen, wird die Ausführung ans Ende verschoben
      setTimeout(() => {
        control.setValue(null);
        control.disable();
      });
    }
  }
}
